import { Button, Col, Form, Input, Row } from 'antd';

import { AgreementFormItem } from './common';

import './index.less';

import { useRequest } from 'ahooks';

const FormBindEmail = (props: any) => {
  const {
    form,
    onFinish,
    handleFieldsChange,
    onSendCode,
    isDisabledSubmit,
    loadingBtn,
    codeBtnDisabled,
    btnContent,
    enable,
  } = props;

  const { run: onSendCodeFn, loading } = useRequest(onSendCode, {
    manual: true,
    loadingDelay: 500,
  });

  return (
    <>
      <div className={'headerGroup'}>
        <div>{'绑定邮箱'}</div>
      </div>

      <div className={'loginForm'}>
        <Form
          form={form}
          size={'large'}
          name="register"
          onFinish={onFinish}
          onFieldsChange={handleFieldsChange}
          scrollToFirstError
        >
          {/*账号信息*/}
          <Form.Item
            name="username"
            label=""
            rules={[
              { required: true, message: '请输入邮箱' },
              {
                pattern: /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                message: '请输入正确的邮箱',
              },
            ]}
          >
            <Input placeholder={'请输入邮箱'} />
          </Form.Item>

          <Form.Item label="">
            <Row gutter={8}>
              <Col span={12}>
                <Form.Item
                  name="code"
                  noStyle
                  rules={[
                    { required: true, message: '请输入验证码' },
                    { pattern: /^[0-9]{6}$/, message: '请输入正确的验证码' },
                  ]}
                >
                  <Input placeholder={'请输入验证码'} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Button
                  block
                  className="codeBtn"
                  disabled={codeBtnDisabled}
                  type={enable ? 'primary' : 'default'}
                  onClick={onSendCodeFn}
                  loading={loading}
                >
                  {btnContent}
                </Button>
              </Col>
            </Row>
          </Form.Item>

          <AgreementFormItem />

          <Form.Item>
            <Button
              type="primary"
              disabled={isDisabledSubmit}
              htmlType="submit"
              loading={loadingBtn}
              block
            >
              绑定
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default FormBindEmail;
